import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Button from '../../../../shared/library/Button/Button';
import classNames from 'classnames';
import PhoneButton from '../Shared/PhoneButton';
import {buildFuneralHomeFlowersUrl} from '../../../../shared/utilities/urlHelpers';
import {gaClickHandler} from '../../../../shared/utilities/GAHelpers';
import './css/InfoButtons.styl';

export class InfoButtons extends Component {
  renderPhoneButton() {
    return (
      <PhoneButton
        isPremium={this.props.isPremium}
        phoneNumber={this.props.phone}
      />
    );
  }

  renderFlowerButton() {
    const prominentClassName = this.props.isPremium ? null : 'prominent-button';
    const {affiliateId, funeralHome, isMobile} = this.props;
    const {funeralHomeId, name, location, flowerSettings} = funeralHome;
    const flowersUrlOptions = {
      funeralHomeId,
      affiliateId,
      cultureCode: location.country.cultureCode,
      funeralHomeName: name,
      flowerSettings,
      isMobile,
    };

    return (
      <Button
        className={classNames('spaced-button', prominentClassName)}
        label="Send Flowers"
        type="large-button"
        href={buildFuneralHomeFlowersUrl(flowersUrlOptions)}
        action={gaClickHandler(
          'fhd_flowers',
          'fhd_fh_flowers_click',
          'fhd_flowers_button'
        )}
      >
        Send Flowers
      </Button>
    );
  }

  renderFlowerAndPhoneButtons() {
    if (this.props.isPremium) {
      return (
        <div className="flower-phone-buttons">
          {this.renderPhoneButton()}
          {this.renderFlowerButton()}
        </div>
      );
    }
    return (
      <div className="flower-phone-buttons">
        {this.renderFlowerButton()}
        {this.renderPhoneButton()}
      </div>
    );
  }

  render() {
    return (
      <div className="funeral-info-buttons">
        {this.props.planning
          ? this.renderPhoneButton()
          : this.renderFlowerAndPhoneButtons()}
      </div>
    );
  }
}

InfoButtons.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  phone: PropTypes.string.isRequired,
  funeralHomeId: PropTypes.number,
  planning: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
};

const mapStateToProps = state => ({
  planning: state.planningStore.isPlanning,
  affiliateId: state.affiliateStore.sourceId,
  funeralHome: state.funeralHomeStore,
  isMobile: state.mobileDetailsStore.any,
});

export default connect(mapStateToProps)(InfoButtons);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/FuneralInfo/InfoButtons.js